/* 🤖 this file was generated by svg-to-ts */
export const matIconHMobiledata: {
  name: 'h-mobiledata';
  data: string;
} = {
  name: 'h-mobiledata',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z"/></svg>`
};
